import React, { Fragment, useState } from 'react';
import { useTranslate } from 'react-admin';

import { CreateForm } from '~/components/ra';
import { CreateButton, Drawer } from '~/components';
import TerminalForm from './TerminalForm';
import { Business } from '~/types';

interface Props {
  businessRecord: Business;
  permissions: string[];
}

const TerminalCreate = (props: Props) => {
  const { businessRecord, permissions } = props;
  const { id, solutionId } = businessRecord;
  const createRecord = {
    businessId: id,
    solutionId,
  };
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const translate = useTranslate();
  const translateLabel = (key: string): string =>
    translate(`resources.businesses.terminals.${key}`);

  return (
    <Fragment>
      <CreateButton
        variant='add'
        onClick={handleOpen}
        disabled={!permissions.includes('business.terminal.create')}
      />
      <Drawer heading={translateLabel('addTerminal')} open={open} onClose={handleClose}>
        <CreateForm
          resource='terminals'
          target='businesses'
          id={id}
          record={createRecord}
          closeParent={handleClose}
        >
          <TerminalForm create businessRecord={businessRecord} />
        </CreateForm>
      </Drawer>
    </Fragment>
  );
};

export default TerminalCreate;
